import { html, type TemplateResult } from 'lit';

export function renderAboutViewPresentation(): TemplateResult {
  return html`
    <div class="about-container">
      <p>
        I'm currently a software engineer figuring out how to move pixels around at <a href="https://firefly.adobe.com/" target="_blank" rel="noopener">Adobe Firefly</a>. I like building things and asking questions. 
        Plan is to start using this as a place to post things, mostly to keep me accountable so if you found your way here, hello! 
      </p>

      <div class="history-section">
        <h3>Background</h3>
        
        <div class="history-list">
          <div class="history-item">
            <span class="history-time">Present</span>
            <div>
              <span class="history-role">Senior Software Engineer</span> — <span class="history-org"><a href="https://firefly.adobe.com/" target="_blank" rel="noopener">Adobe Firefly</a></span>
              <div class="history-desc">Image Editing</div>
            </div>
          </div>

          <div class="history-item">
            <span class="history-time">2019 — 2023</span>
            <div>
              <span class="history-role">Sc.B. in Computer Science</span> — <span class="history-org">Brown University</span>
              <div class="history-desc">magna cum laude • Concentration Honors • Senior CS Prize Winner • Head TA for CS1951V (Hypertext & Hypermedia)</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}
